import type { IconNode } from '../types';

/**
 * @name razor
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMjIgMTEtMS42IDEuNmMtLjguOC0yIC44LTIuOCAwbC02LjItNi4yYy0uOC0uOC0uOC0yIDAtMi44TDEzIDIiIC8+CiAgPHBhdGggZD0ibTE1LjggNC44IDMuNCAzLjQiIC8+CiAgPHBhdGggZD0iTTE3IDEyYy0xLjQgMS40LTMuNiAxLjQtNC45IDBzLTEuNC0zLjYtLjEtNSIgLz4KICA8cGF0aCBkPSJtMTEuMSAxMC4xLTguNSA4LjVhMS45NSAxLjk1IDAgMSAwIDIuOCAyLjhsOC40LTguNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/razor
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const razor: IconNode = [
  ['path', { d: 'm22 11-1.6 1.6c-.8.8-2 .8-2.8 0l-6.2-6.2c-.8-.8-.8-2 0-2.8L13 2', key: '1tx23h' }],
  ['path', { d: 'm15.8 4.8 3.4 3.4', key: 'stvobr' }],
  ['path', { d: 'M17 12c-1.4 1.4-3.6 1.4-4.9 0s-1.4-3.6-.1-5', key: '1eq5o8' }],
  ['path', { d: 'm11.1 10.1-8.5 8.5a1.95 1.95 0 1 0 2.8 2.8l8.4-8.4', key: '1ohdts' }],
];

export default razor;
